<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1354_9385)">
            <path
                d="M6 12C2.69 12 0 9.31 0 6C0 2.69 2.69 0 6 0C9.31 0 12 2.69 12 6C12 9.31 9.31 12 6 12ZM3 4.5C3 6.14 5.97 10.46 6 10.5C6 10.5 6 10.49 6.02 10.47C6.3 10.06 9 6.06 9 4.5C9 3.7 8.68 2.94 8.12 2.38C7.56 1.82 6.79 1.5 6 1.5C5.21 1.5 4.44 1.82 3.88 2.38C3.32 2.94 3 3.71 3 4.5ZM4.61 3.93C4.5 4.2 4.47 4.51 4.53 4.8C4.59 5.09 4.73 5.36 4.94 5.57C5.15 5.78 5.42 5.92 5.71 5.98C6 6.04 6.3 6.01 6.58 5.89C6.85 5.78 7.09 5.58 7.25 5.34C7.41 5.09 7.5 4.8 7.5 4.51C7.5 4.11 7.34 3.73 7.06 3.45C6.78 3.17 6.4 3.01 6 3.01C5.7 3.01 5.41 3.1 5.17 3.26C4.92 3.42 4.73 3.66 4.62 3.93H4.61Z"
            />
        </g>
        <defs>
            <clipPath id="clip0_1354_9385">
                <rect width="12" height="12" />
            </clipPath>
        </defs>
    </svg>
</template>
